export default __webpack_public_path__ + "static/media/GASTRONOMIE.c387df9f.svg";